// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-light[data-v-627cf464]{background-color:#f8fafc}.w-100[data-v-627cf464]{width:100%}", ""]);
// Exports
module.exports = exports;
